module.exports = __webpack_public_path__ + "img/background27.36860562.jpg";